import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import HelperCapacityOverview from 'utils/helper-capacity-overview'
import HelperTimeslotGroups from 'utils/helper/HelperTimeslotGroups'
import useSelectTimeslotGroups from 'utils/hooks/use-select-timeslot-groups'
import _ from 'lodash'
import { routeBookingConstants } from 'utils/constants/route/RouteBookingConstants'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { cartConstants } from 'services/redux/cart/constants'
import useRouteParameters from 'utils/hooks/use-route-parameters'
import useRouteParametersForcedGuids from 'utils/hooks/use-route-parameters-forced-guids'
import { useInterval } from 'utils/hooks/use-interval'
import ValidateBookingFunctions from 'scenes/home/book/validate/_functions/ValidateBookingFunctions'
import FetchTimeslotCapacity from 'utils/fetch/FetchTimeslotCapacity'

const defaultState = {}

const BookContext = React.createContext( defaultState )

export const useBookProvider = () => {
	return useContext(BookContext);
}

const BookProvider = ({ children }) => {
	
	const [ route, setRoute ] = useState( {} )
	
	const capacityLoadingRef = useRef( {} );
	const [ capacityLoading, setCapacityLoading ] = useState( {} );
	
	const _routeParameters = useRouteParameters( route );
	const _forcedGuids = useRouteParametersForcedGuids( route );
	
	const _timeslotGroup = useSelectTimeslotGroups( _forcedGuids )[ _.get( _routeParameters, routeBookingConstants.TIMESLOT_GROUP ) ];
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} ); // do not remove, required for reloading
	const _bookDate = useSelector( state => {
		return state.cart[cartConstants.BOOK_DATE];
	} ); // KEEP BUILDINGS FOR THE RELOAD OF THE PAGE
	const _cartBookings = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS];
	} );
	
	const { timeslotKinds, timeslotSubKinds, timeslotKindsForGroup } = HelperTimeslotGroups.getKindsAndSubKinds( _timeslotGroup, _timeslotKinds );
	
	const cartBookingsFlat = useMemo( () => {
		return ValidateBookingFunctions.createFlatList( _cartBookings )
	}, [ _cartBookings ])
	
	const onUpdateCapacityLoading = ( loading, date ) => {
		capacityLoadingRef.current[ date ] = loading;
		
		setCapacityLoading( capacityLoadingRef.current );
	}
	
	const onFetchCapacities = () => {
		// Check if it is already loading
		if( capacityLoadingRef.current[ _bookDate ] ) {
			return;
		}
		
		// Set it loading (force here already)
		capacityLoadingRef.current[ _bookDate ] = true;
		
		HelperCapacityOverview.fetchCapacities({
			timeslotKinds: timeslotKinds,
			timeslotSubKinds: timeslotSubKinds,
			onStart: onUpdateCapacityLoading.bind( this, true ),
			onComplete: onUpdateCapacityLoading.bind( this, false ),
			onNothingToDo: onUpdateCapacityLoading.bind( this, false )
		});
	}
	
	const onFetchTimeslotCapacities = () => {
		FetchTimeslotCapacity.fetchByBookings( cartBookingsFlat );
	}
	
	useEffect( () => {
		return onFetchCapacities();
	}, [ route, _bookDate ] );
	useEffect( () => {
		return onFetchTimeslotCapacities();
	}, [ cartBookingsFlat ] );
	
	useInterval( () => {
		// Check every 10 seconds
		onFetchCapacities()
		
		// Check every 10 seconds
		onFetchTimeslotCapacities();
	}, 10 * 1000 );
	
	return (
		<BookContext.Provider
			value={{
				setRoute: setRoute,
				capacityLoading: capacityLoading,
				
				bookDate: _bookDate,
				_timeslotGroup: _timeslotGroup,
				
				timeslotKinds,
				timeslotSubKinds,
				timeslotKindsForGroup,
			}}>
			
			{ children }
		</BookContext.Provider>
	)
}

export default BookProvider
